import { render, staticRenderFns } from "./profile-status.vue?vue&type=template&id=449c4946"
import script from "./profile-status.vue?vue&type=script&lang=js"
export * from "./profile-status.vue?vue&type=script&lang=js"
import style0 from "./profile-status.vue?vue&type=style&index=0&id=449c4946&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports